import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from '../../../../services/common.service';
import {ExcelService} from '../../../../services/excel.service';
import {ReportService} from '../../../../services/report.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {CustomFormsHistoryDetailsDialogComponent} from '../../custom-form-reports/custom-form-completed/custom-forms-history-details-dialog/custom-forms-history-details-dialog.component';

@Component({
  selector: 'app-custom-form-parent-completed',
  templateUrl: './custom-form-parent-completed.component.html',
  styleUrls: ['./custom-form-parent-completed.component.scss']
})
export class CustomFormParentCompletedComponent implements OnInit, AfterViewInit {
  uniqueId: string;
  forms: MatTableDataSource<any> = new MatTableDataSource<any>();
  originalForms = [];
  isLoading;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  displayColumns = ['displayName', 'title', 'published_at', 'modified_by_displayName', 'modified_at', 'isChecked', 'actions'];
  constructor(private reportService: ReportService,
              public router: Router,
              public excelService: ExcelService,
              public dialog: MatDialog,
              public route: ActivatedRoute,
              private commonService: CommonService,
              public toastMessagesService: ToastMessagesService) {
    this.isLoading = true;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.uniqueId = params.formUniqueId;
      console.log(this.uniqueId);
    });
  }

  async ngAfterViewInit() {
    await this.initializeForms();
  }

  async initializeForms() {
    try {
      const forms = [];
      const formsRequest = await this.reportService.getCustomFormsParentsReport(1, this.uniqueId);

      console.log(formsRequest);
      for (const form of formsRequest) {
        form.displayName = `${form.first_name} ${form.last_name}`;
        form.modified_by_displayName = form.modified_by ?  `${form.modified_by_first_name} ${form.modified_by_last_name}` : '-';
        if (forms.findIndex(f => f.uniqueId === form.uniqueId && f.id === form.id) === -1) {
          forms.push(form);
        } else {
          this.originalForms.push(form);
        }
      }

      this.forms = new MatTableDataSource<any>(forms);
      this.forms.sort = this.sort;
    } catch (e) {
      console.log(e);
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φορτώσουμε τις ολοκληρωμένες φόρμες');
    } finally {
      this.isLoading = false;
    }
  }

  search(value: any) {
    this.forms.filter = value.trim().toLowerCase();
  }


  async editForm(form) {
    const inputConfig = {
      edit: true,
      childId: form.child_id,
      mode: false,
      parentId: form.notification_to_parent,
      unique_id: form.uniqueId,
      checkParentId: form.parent_id,
      version: 'latest',
      id: form.id,
    };
    console.log(inputConfig);
    // parentRequestForm?isExternal=true&mode=false&unique_id=xmr4grv8ddt
    await this.router.navigate(['/home/parentRequestForm'], {queryParams: inputConfig});
  }

  getHistoryCount(form) {
    const displayForms = this.originalForms.filter(f => f.child_id === form.child_id);
    return displayForms.length;
  }

  async checkForm(form, status) {
    try {
      await this.reportService.validateParentForm(form.id, status);
      await this.initializeForms();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async showHistory(form) {
    const displayForms = this.originalForms.filter(f => f.child_id === form.child_id);
    this.dialog.open(CustomFormsHistoryDetailsDialogComponent, {
      data: {
        displayForms
      }
    });
  }
}
